import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';

function Profile() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSearch = (query: string) => {
    // Navigate to home page with search query
    navigate(`/?search=${encodeURIComponent(query)}`);
  };

  return (
    <>
      <Navbar onSearch={handleSearch} />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold mb-6">Profile</h1>
          
          <div className="space-y-4">
            <div className="flex items-center space-x-4">
              {user?.photoURL ? (
                <img
                  src={user.photoURL}
                  alt={user.displayName || 'Profile'}
                  className="w-16 h-16 rounded-full"
                />
              ) : (
                <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center">
                  <span className="text-2xl font-bold text-gray-600">
                    {user?.displayName?.[0] || user?.email?.[0]}
                  </span>
                </div>
              )}
              <div>
                <h2 className="text-xl font-semibold">{user?.displayName || 'User'}</h2>
                <p className="text-gray-600">{user?.email}</p>
              </div>
            </div>

            <div className="border-t pt-4">
              <h3 className="text-lg font-semibold mb-2">Account Details</h3>
              <div className="space-y-2">
                <p>
                  <span className="font-medium">Role:</span>{' '}
                  <span className="capitalize">{user?.role || 'User'}</span>
                </p>
                <p>
                  <span className="font-medium">Account Status:</span>{' '}
                  <span className="text-green-600">Active</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;